<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="8" cols="12">
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-breadcrumb />
                    </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <loading :active="loadCounter > 0" color='#007bff' :width='128' :height='128' loader='dots'
                :can-cancel="true" :is-full-page="true">
            </loading>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col lg="6">
                                        <div>
                                            <span style="font-weight: bold">{{document_title}} </span>
                                        </div>
                                    </b-col>
                                    <b-col lg="6">
                                        <base-button icon type="default" class="float-right mr-4" @click.native="onClickHistory" v-if="receipt.contact_id != null"><i class="fas fa-question"></i></base-button>
                                        <base-button icon type="success" class="float-right mr-4" @click="editDocument"
                                            v-if="(is_edit == 0 && receipt.is_void != '1' && receipt.time_printed == null)">
                                            <i class="fas fa-edit"></i>
                                        </base-button>

                                        <base-button icon type="warning" class="float-right mr-4" @click="voidDocument"
                                            v-if="($route.params.id != '_new' && receipt.is_void != '1' && receipt.time_printed == null)">
                                            {{language_terms['VOID']}}
                                        </base-button>
                                        <i class="fa fa-exclamation-triangle float-right text-red fa-3x"
                                            v-if="receipt.is_void == '1'"></i>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col md="2">
                                    <base-input :label="language_terms['PAYMENT_MODE']">
                                        <el-select @change="retrieveItems(receipt.contact_id)"
                                            v-model="receipt.mode" filterable
                                            :placeholder="language_terms['PAYMENT_MODE']" :disabled="!is_edit || receipt.code != null">
                                            <el-option v-for="option in payment_modes" :key="option.code"
                                                :label="language_terms[option.name]" :value="option.code">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" v-if="0">
                                    <base-input label="Apply Mode">
                                        <el-select @change="onChangeApplyModeType"
                                            v-model="receipt.apply_mode" filterable
                                            :disabled="!is_edit || receipt.mode == 'REFUND'">
                                            <el-option v-for="option in apply_mode_options" :key="option.code"
                                                :label="option.name" :value="option.name">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="6">
                                    <label class="form-control-label">{{language_terms['ENTITY']}}</label>
                                    <base-input v-model="receipt.contact_name"
                                        v-if="(!is_edit || $route.params.id != '_new')" disabled/>
                                    <multiselect v-else :internalSearch="false" v-model="receipt.contact"
                                        ref="multiselcetRef" label="name" track-by="id" open-direction="bottom"
                                        :preserve-search="false" :options="contacts" :multiple="false"
                                        :searchable="true" :clear-on-select="false" :close-on-select="true"
                                        :options-limit="300" :limit="50" :limit-text="limitText" :max-height="600"
                                        :show-no-results="false" :hide-selected="false" @search-change="findEntity"
                                        @input="onSelectEntity"
                                        :taggable="receipt.default_creditor_account_code != this.default_creditor_account_code"
                                        @tag="addTag($event)">
                                    </multiselect>
                                </b-col>
                                <b-col md="2">
                                    <base-input :label="language_terms['SETTLEMENT_CURRENCY']">
                                        <el-select @change="retrieveItems(receipt.contact_id)"
                                            v-model="receipt.currency_code" filterable :disabled="!is_edit || receipt.code != null">
                                            <el-option v-for="option in currencies" :key="option.id"
                                                :label="option.code" :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2">
                                    <base-input :label="language_terms['TOTAL_AMOUNT']"
                                        :value="(receipt.amount * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })"
                                        disabled/>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="2">
                                    <base-input :label="language_terms['DATE']" v-if="is_edit">
                                        <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                            style="background-color: white" class="form-control datepicker"
                                            v-model="receipt.date">
                                        </flat-picker>
                                    </base-input>
                                    <base-input :label="language_terms['DATE']" v-model="receipt.date" v-if="!is_edit"
                                        type="date" disabled/>
                                </b-col>
                                <b-col md="2" v-if="requires_bankaccount == 1 || !is_edit">
                                    <base-input :label="language_terms['BANK_ACCOUNT']">
                                        <el-select v-model="receipt.bankaccount_id" filterable
                                            :placeholder="language_terms['BANK_ACCOUNT']" :disabled="!is_edit">
                                            <el-option v-for="option in company_bankaccounts" :key="option.id"
                                                :label="option.code" :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" v-if="requires_bankaccount == 1 && receipt.mode != 'BULK_PAYMENT' || !is_edit">
                                    <base-input v-model="receipt.bank_fees_amount"
                                        :label="language_terms['BANK_CHARGE']"
                                        :placeholder="language_terms['BANK_CHARGE']" type="number"
                                        :disabled="!is_edit "/>
                                </b-col>
                                <b-col md="2" v-if="requires_bankaccount == 1 && receipt.mode != 'BULK_PAYMENT' || !is_edit">
                                    <base-input label="Bank Charge Account">
                                        <el-select v-model="receipt.bankcharge_bankaccount_id" filterable
                                            :placeholder="language_terms['BANK_ACCOUNT']" :disabled="!is_edit ">
                                            <el-option v-for="option in company_bankaccounts" :key="option.id"
                                                :label="option.code" :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="4">
                                    <base-input v-model="receipt.reference" :label="language_terms['REFERENCE']"
                                        :disabled="!is_edit"/>
                                </b-col>
                                <b-col md="2" v-if="receipt.mode == 'DN'">
                                    <base-input v-if="is_edit == 1" label="GST (%)" type="number" v-model="receipt.tax_rate_percent" @change="recomputeCNAmount()" :disabled="!is_edit || receipt.code != null"/>
                                    <base-input v-else v-model="receipt.tax_rate_percent" label="GST (%)" :disabled="!is_edit"/>
                                </b-col>

                                <b-col md="12">
                                    <base-input :label="language_terms['REMARKS']">
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" :disabled="!is_edit" v-model="receipt.remarks"/>
                                    </base-input>
                                </b-col>
                            </b-row>

                            <b-card v-if="(receipt.apply_mode == 'INVOICE' && receipt.mode != 'REFUND') && receipt.contact != null && receipt.currency_code != null && receipt.items.length >= 0 && ((!is_edit && receipt.code != null) || (is_edit && receipt.code == null))">
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="12">
                                            <h3>Bill Payment</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col md="2" v-if="requires_bankaccount == 1 && (receipt.contact != null && this.receipt.items.length >= 0 || this.receipt.pitems.length != 0)">
                                        <base-input v-model="receipt.amount" :label="language_terms['PAID_AMOUNT']" type="number" :disabled="!is_edit"/>
                                    </b-col>
                                    <b-col md="1" v-if="requires_bankaccount == 1 && (receipt.contact != null && this.receipt.items.length >= 0 || this.receipt.pitems.length != 0)">
                                        <base-input v-model="receipt.amount_adjusted" :label="language_terms['ADJUSTMENT']" type="number" :disabled="!is_edit"/>
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :value="(total_sales_os_amount_home * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled :label="'Total O/S Amount'"/>
                                    </b-col>
                                    <b-col md="1">
                                        <base-input :value="((receipt.amount * 1 + receipt.amount_adjusted * 1) - total_allocated_amount * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled label="Unallocated"/>
                                    </b-col>
                                    <b-col md="2" v-if="receipt.pending_offset_amount_home && receipt.pending_offset_amount_home != 0">
                                        <base-input :value="(receipt.pending_offset_amount_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled label="Offset Amount (SGD)" ></base-input>
                                    </b-col>

                                    <b-col md="4" class="mt-4">
                                        <base-button class="mt-2" type="danger" @click="onClickOffset()"
                                            v-if="is_edit && receipt.mode != 'CONTRA' && receipt.pending_offset_amount_home != 0
                                            && requires_bankaccount == 1 && (receipt.contact != null && this.receipt.items.length >= 0 || this.receipt.pitems.length != 0)"
                                            >
                                            Offset
                                        </base-button>
                                        <base-button class="mt-2" type="primary"  @click="onClickExchangeRates()" v-if="is_edit && receipt.mode != 'CONTRA' && receipt.currencies.length > 0">Exchange Rates</base-button>
                                        <base-button class="mt-2" type="info" @click.native="onClickAutoSum" v-if="is_edit && receipt.mode != 'CONTRA'
                                        && requires_bankaccount == 1 && (receipt.contact != null && this.receipt.items.length >= 0 || this.receipt.pitems.length != 0)">Auto Sum</base-button>
                                        <base-button class="mt-2" type="success" @click.native="onClickAutoApply" v-if="is_edit && receipt.mode != 'CONTRA'
                                        && requires_bankaccount == 1 && (receipt.contact != null && this.receipt.items.length >= 0 || this.receipt.pitems.length != 0)">Auto Apply</base-button>
                                    </b-col>
                                </b-row>
                                <b-row class="" v-if="receipt.contact != null && receipt.items.length > 0 && receipt.currency_code != null">
                                    <!-- <b-col md="12">
                                        <b>{{
                                            $route.params.id == '_new' ? receipt.items.length + ' ' +
                                                language_terms["OUTSTANDING_INVOICES"] : language_terms["INVOICES"]
                                       }}</b>
                                    </b-col> -->
                                    <b-col sm="12">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['DATE']}}</b-th>
                                                <b-th>{{language_terms['DOCUMENT']}}</b-th>
                                                <b-th>{{language_terms['CURRENCY']}}</b-th>
                                                <b-th>Doc Amount
                                                    ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>Home (SGD)</b-th>
                                                <!-- <b-th></b-th> -->
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(invoice, i) in receipt.items" :key="i" @click="onClickApply(invoice, i)">
                                                    <td>{{invoice.document_date}}</td>
                                                    <td>
                                                        {{receipt.mode == 'REFUND' ?
                                                            invoice.code + invoice.document_number + (invoice.document_reference != null ? ' / ' + invoice.document_reference : '')
                                                            :
                                                            invoice.document_number + (invoice.document_reference != null ? ' / ' + invoice.document_reference : '')
                                                        }}
                                                    </td>
                                                    <td>{{invoice.currency_code}}</td>
                                                    <td>{{invoice.document_type == 'R' ? '(' : ''}}
                                                        {{receipt.mode == 'REFUND' ?
                                                            is_edit ? (invoice.document_nett_amount * 1).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (invoice.document_amount * 1).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                            :
                                                            is_edit ? (invoice.document_nett_amount * 1).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (invoice.document_amount * 1).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        }}
                                                        {{invoice.document_type == 'R' ? ')' : ''}}
                                                    </td>

                                                    <td>
                                                        <span v-if="(!is_edit)">{{invoice.document_amount_os}}</span>
                                                        <span v-else>
                                                            {{invoice.document_type == 'R' ? '(' : ''}}
                                                            {{(invoice.balance_exclude ? invoice.balance_exclude :
                                                        invoice.balance * 1).toLocaleString('en-US',
                                                            { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}
                                                            {{invoice.document_type == 'R' ? ')' : ''}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount" @input="performExchange(invoice)"
                                                            type="number"
                                                            v-if="is_edit"/>
                                                        <span v-else>{{invoice.amount_settlement}}</span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount_settlement"
                                                            type="number"
                                                            v-if="is_edit" :disabled="invoice.currency_code == receipt.currency_code"/>
                                                        <span v-else>{{ invoice.amount_settlement }}</span>
                                                    </td>
                                                    <!-- <td>
                                                        <base-button type="success"
                                                            @click.native="onClickApply(invoice, i)" class="mr-4"
                                                            v-if="is_edit && receipt.mode != 'CONTRA'">
                                                            {{language_terms['APPLY']}}
                                                        </base-button>
                                                    </td> -->
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4" v-if="receipt.contact != null && receipt.items.length > 0 && receipt.currency_code != null && receipt.mode == 'CONTRA' && receipt.pitems.length != 0">
                                    <b-col md="12">
                                        <b>{{
                                            $route.params.id == '_new' ?
                                                language_terms["OUTSTANDING_PURCHASE_INVOICES"] :
                                                language_terms["PURCHASE_INVOICES"]
                                       }}</b>
                                    </b-col>
                                    <b-col cols="12" class="mt-3">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['DATE']}}</b-th>
                                                <b-th>{{language_terms['INVOICE_NUMBER']}}</b-th>
                                                <b-th>{{language_terms['INVOICE_AMOUNT']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(invoice, i) in receipt.pitems" :key="i">
                                                    <td>{{moment(invoice.document_date).format("DD/MM/YYYY")}}</td>
                                                    <td>{{invoice.document_number}}</td>
                                                    <td>{{invoice.document_amount}}</td>
                                                    <td>
                                                        <span v-if="(!is_edit)">{{invoice.balance}}</span>
                                                        <span v-else>{{invoice.balance_exclude ? invoice.balance_exclude : invoice.balance}}</span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount" type="number" v-if="is_edit"/>
                                                        <span v-else>{{invoice.amount}}</span>
                                                    </td>
                                                    <td>
                                                        <base-button type="success" @click.native="onClickApply(invoice, i)" class="mr-4" v-if="is_edit && receipt.mode != 'CONTRA'">
                                                            {{language_terms['APPLY']}}
                                                        </base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <b-card v-if="(receipt.apply_mode == 'GL') && receipt.mode != 'REFUND' && receipt.contact != null && receipt.currency_code != null">
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="10">
                                            <h3>{{language_terms['RECEIVE_FOR']}}</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row v-if="is_edit">
                                    <b-col :md="item.account_item.is_taggable == '1' ? 3 : 6">
                                        <label class="form-control-label">{{language_terms['ACCOUNT']}}</label>
                                        <multiselect v-model="item.account_item" :disabled="!is_edit"
                                            :options="account_list" track-by="code" :multiple="false"
                                            :close-on-select="true" :clear-on-select="false" open-direction="bottom"
                                            label="name" text-field="display_name" />
                                    </b-col>
                                    <b-col md="3"
                                        v-if="is_edit && item.account_item.is_taggable == '1'">
                                        <label class="form-control-label">{{language_terms['ACCOUNT_TAG']}}</label>
                                        <multiselect v-model="item.account_item_tag" :disabled="!is_edit"
                                            :options="item.account_item.tags" :multiple="false" :taggable="true"
                                            @tag="addAccountItemTag($event)" />
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :label="language_terms['AMOUNT']" v-model="item.amount"
                                            type="NUMBER" :disabled="!is_edit"/>
                                    </b-col>
                                    <b-col md="3">
                                        <base-input :label="language_terms['REMARKS']" v-model="item.remarks"
                                            :disabled="!is_edit"/>
                                    </b-col>
                                    <b-col md="1" class="mt-4">
                                        <b-button variant="primary" @click="addAccountItem()" :disabled="!is_edit"
                                            class="mt-2">
                                            {{language_terms['ADD']}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" v-if="receipt.items.length > 0">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['ACCOUNT_CODE']}}</b-th>
                                                <b-th>{{language_terms['ACCOUNT_NAME']}}</b-th>
                                                <b-th>{{language_terms['AMOUNT']}}</b-th>
                                                <b-th>{{language_terms['REMARKS']}}</b-th>
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(item, index) in receipt.items" :key="index">
                                                    <td>{{item.account_item_code}}</td>
                                                    <td>{{item.account_item_name}}{{
                                                        item.account_item_tag != null ? ' ('
                                                            + item.account_item_tag + ')' : ''
                                                   }}</td>
                                                    <td>{{(item.amount * 1).toLocaleString('en-US',
                                                    { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
                                                    <td>{{item.remarks}}</td>
                                                    <td v-if="is_edit">
                                                        <base-button size="sm" icon type="danger"
                                                            @click="deleteItem(index)"><i
                                                                class="fas fa-trash-alt"></i></base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <b-card v-if="receipt.mode == 'REFUND' && receipt.contact != null && receipt.currency_code != null">
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="12">
                                            <h3>Refund</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row v-if="requires_bankaccount == 1 && (receipt.contact != null && this.receipt.items.length >= 0 || this.receipt.pitems.length != 0)">
                                    <b-col md="2">
                                        <base-input v-model="receipt.amount" :label="language_terms['REFUND_AMOUNT']" type="number" disabled/>
                                    </b-col>
                                    <!-- <b-col md="2">
                                        <base-input v-model="receipt.amount_adjusted" :label="language_terms['ADJUSTMENT']" type="number" :disabled="!is_edit"/>
                                    </b-col> -->
                                    <b-col md="2">
                                        <base-input :value="(total_sales_os_amount_home * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled :label="language_terms['TOTAL_OUTSTANDING_AMOUNT']"/>
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :value="((receipt.amount * 1 + receipt.amount_adjusted * 1) - total_allocated_amount * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled :label="language_terms['UNALLOCATED_AMOUNT']"/>
                                    </b-col>
                                    <b-col md="4" class="mt-4">
                                        <base-button class="mt-2" type="primary"  @click="onClickExchangeRates()" v-if="is_edit && receipt.mode != 'CONTRA' && receipt.currencies.length > 0">Exchange Rates</base-button>
                                        <base-button class="mt-2" type="info" @click.native="onClickAutoSum" v-if="is_edit && receipt.mode != 'CONTRA'">Auto Sum</base-button>
                                        <base-button class="mt-2" type="success" @click.native="onClickAutoApply" v-if="is_edit && receipt.mode != 'CONTRA'">Auto Apply</base-button>
                                    </b-col>
                                </b-row>
                                <!---<p>{{this.receipt.customer}}</p>debug-->
                                <b-row class=""
                                    v-if="receipt.contact != null && receipt.items.length > 0 && receipt.currency_code != null">
                                    <b-col md="12">
                                        <b>{{
                                            $route.params.id == '_new' ? receipt.items.length + ' ' +
                                                language_terms["RECEIPTS"] : language_terms["RECEIPTS"]
                                       }}</b>
                                    </b-col>
                                    <b-col sm="12" class="mt-3">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['DATE']}}</b-th>
                                                <b-th>{{language_terms['DOCUMENT']}}</b-th>
                                                <b-th>{{language_terms['CURRENCY']}}</b-th>
                                                <b-th>{{language_terms['RECEIPT_AMOUNT']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{'Settlement'}} ({{receipt.currency_code}})</b-th>
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(item, i) in receipt.items" :key="i">
                                                    <td>{{item.date}}</td>
                                                    <td>{{item.code}}</td>
                                                    <td>{{item.currency_code}}</td>
                                                    <td>{{(item.document_amount * 1).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
                                                    <td>{{(item.balance * 1).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
                                                    <td>
                                                        <base-input v-model="item.amount" @input="performExchange(item)" type="number" v-if="is_edit"/>
                                                        <span v-else>{{item.amount_settlement}}</span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="item.amount_settlement" type="number" :disabled="!is_edit || item.currency_code == receipt.currency_code"/>
                                                    </td>
                                                    <td>
                                                        <base-button type="success" @click.native="onClickApply(item, i)" class="mr-4" v-if="is_edit && receipt.mode != 'CONTRA'">
                                                            {{language_terms['APPLY']}}
                                                        </base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4" v-if="receipt.contact != null && receipt.items.length > 0 && receipt.currency_code != null && receipt.mode == 'CONTRA' && receipt.pitems.length != 0">
                                    <b-col md="12">
                                        <b>{{
                                            $route.params.id == '_new' ?
                                                language_terms["OUTSTANDING_PURCHASE_INVOICES"] :
                                                language_terms["PURCHASE_INVOICES"]
                                       }}</b>
                                    </b-col>
                                    <b-col cols="12" class="mt-3">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['DATE']}}</b-th>
                                                <b-th>{{language_terms['INVOICE_NUMBER']}}</b-th>
                                                <b-th>a {{language_terms['INVOICE_AMOUNT']}}
                                                    ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(invoice, i) in receipt.pitems" :key="i">
                                                    <td>{{moment(invoice.document_date).format("DD/MM/YYYY")}}</td>
                                                    <td>{{invoice.document_number}}</td>
                                                    <td>{{invoice.document_amount}}</td>
                                                    <td>
                                                        <span v-if="(!is_edit)">{{invoice.balance}}</span>
                                                        <span v-else>{{invoice.balance_exclude ? invoice.balance_exclude : invoice.balance}}</span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount" type="number" v-if="is_edit" />
                                                        <span v-else>{{invoice.amount}}</span>
                                                    </td>
                                                    <td>
                                                        <base-button type="success" @click.native="onClickApply(invoice, i)" class="mr-4" v-if="is_edit && receipt.mode != 'CONTRA'">
                                                            {{language_terms['APPLY']}}
                                                        </base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card>  

                            <div class="floating-bar"
                                v-if="receipt.contact != null && receipt.items.length >= 0 && receipt.currency_code != null">
                                <div class="floating-bar-container" align="center">
                                    <b-button-group>
                                        <b-button class="transparent-btn" @click="onClickEdit()"  v-if="!is_edit">
                                        <i class="fas fa-edit mr-2 text-info"></i>{{language_terms['EDIT']}}
                                        </b-button>
                                        <b-button class="transparent-btn" @click="printDocument"  v-if="!is_edit">
                                        <i class="fas fa-print mr-2 text-info"></i>{{language_terms['PRINT']}}
                                        </b-button>
                                        <b-button class="transparent-btn" @click="saveDocument" v-if="is_edit">
                                            <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                        </b-button>
                                        <b-button class="transparent-btn" @click="onClickClose">
                                            <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CLOSE']}}
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </div>
                        </card>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <b-modal id="modal-history" header-bg-variant="dark" centered class="my-modal" size="xl" hide-footer>
            <template>
                <b-row class="align-items-center mt--2">
                <b-col md="12" fluid class="mt--7">
                    <h3 style="color: white;">Payment History</h3>
                </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col lg="12" md="10" sm="8" class="mb-3">
                <b-form-input v-model="history.filter" type="search" placeholder="Search"></b-form-input>&nbsp;
                </b-col>
                <b-col cols="12">
                    <div class="table-responsive">
                    <b-pagination
                        v-model="history.currentPage"
                        :total-rows="history.data.length"
                        :per-page="history.perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                        <b-table
                            :items="history.data"
                            :fields="history.fields"
                            :current-page="history.currentPage"
                            :filter="history.filter"
                            :filter-included-fields="history.filterOn"
                            :per-page="history.perPage"
                            show-empty
                            @filtered="onFiltered">
                            <template #cell(amount)="row">
                            {{(row.item.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="modal-currencies" hide-footer>
            <template #modal-title>
            Currency Exchange Rates (To SGD)
            </template>
            <div class="d-block text-center">
                <b-table-simple hover responsive>
                    <b-thead head-variant="light">
                        <b-th>{{language_terms['CURRENCY']}}</b-th>
                        <b-th>Booked Rate</b-th>
                    </b-thead>
                    <b-tbody>
                        <tr v-for="(currency, i) in receipt.currencies" :key="i">
                            <td><h1>{{currency.currency_code}} to SGD</h1></td>
                            <td><base-input :disabled="currency.currency_code == receipt.currency_code" v-model="currency.exchange_rate" type="number"/></td>
                        </tr>
                    </b-tbody>
                </b-table-simple>            
            </div>
            <base-button type="success" class="mt-3" block @click="onClickBookExchange">Book Rates</base-button>
        </b-modal>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// import RefundComponent from "./refundComponent.vue"
import axios from "axios";
import { apiRoutes } from "../../../apiRoutes";
import { authHeader } from "../../../global";
import moment from "moment";
import Vue from 'vue'
import BaseInput from '../../../components/Inputs/BaseInput.vue';
import { allowedNodeEnvironmentFlags } from "process";

export default {
    components: {
        Loading,
        [Select.name]: Select,
        flatPicker,
        [Option.name]: Option,
        BaseInput,
    },
    computed: {
        requires_bankaccount()
        {
            let v = 0
            this.payment_modes.forEach((o, i) =>
            {
                if (o.code == this.receipt.mode)
                    v = o.requires_bankaccount
            })

            return v
        },
        ...mapState({
            language_terms: (state) => state.languages.language_terms,
            selected_lang: (state) => state.languages.selected_langauge,
            outstanding_sales_invoices: (state) => state.sales.outstanding_sales_invoices,
            currency_prefix: (state) => state.currencies.prefix,
            is_receipt_created: (state) => state.receipts.is_created,
            is_receipt_updated: (state) => state.receipts.is_updated,
            receipt_is_voided: (state) => state.receipts.is_voided,
            receipt_filter: (state) => state.receipts.filter,
            receipt_data: (state) => state.receipts.data,
            company_bankaccounts: (state) => state.bankAccounts.company_bankaccounts,
            fys: (state) => state.accounts.fys,
            accounts_for_fy: (state) => state.accounts.accounts_for_fy,
            fy_by_date: (state) => state.accounts.fy_by_date

        }),
        total_sales_os_amount_home: function () {
            var total = 0

            if (this.receipt.items.length > 0) {
                this.receipt.items.forEach((o, index) => {
                    total += this.fxAmountToHomeCurrency(o.currency_code, o.balance * 1) * 1
                })
            }

            if (isNaN(total))
                total = 0
                
            return parseFloat((total * 1).toFixed(2));
        },

        total_purchases_os_amount: function () {
            if (!this.receipt.pitems) {
                return 0;
            }
            return this.receipt.pitems.reduce(function (total, value) {
                let balance_amount = (value.balance_exclude ? value.balance_exclude : value.balance)
                total = total + Number(balance_amount);
                return parseFloat(total.toFixed(2));
            }, 0);
        },


        total_allocated_amount: function ()
        {
            var amount = 0

            if (this.is_edit)
            {
                if (!this.receipt.items) {
                    amount = 0
                }
                else
                {
                    this.receipt.items.forEach((o, index) => {
                        if (o.amount_settlement && !isNaN(o.amount_settlement))
                            amount += (o.amount_settlement * 1)
                    })
                }
                amount = this.fxHomeAmountToCurrency(this.receipt.currency_code, amount)
            }
            else
            {
                this.receipt.items.forEach((o, index) => {
                    amount += (o.amount_settlement * 1)
                    // amount += o.amount * 1 * o.exchange_rate 
                })
            }
            return amount
        }
    },
    data() {
        return {
            default_creditor_account_code: null,
            history:{
                currentPage: 1,
                perPage: 10,
                filter:"",
                filterOn:[],
                fields:[
                    { key: 'date', label: 'Date', sortable: true, sortDirection: 'desc' },
                    { key: 'code', label: 'PV #', sortable: true, sortDirection: 'desc' },
                    { key: 'currency_code', label: 'Currency'},
                    { key: 'amount', label: 'Amount'},
                    { key: 'bank_code', label: 'Bank A/C'},
                    { key: 'reference', label: 'Reference'},
                    { key: 'docs', label: 'Bills'},
                ],
                data:[],
            },
            doc_number: null,
            type: 'PURCHASE',
            ramount: null,
            fy: null,
            account_list: [],
            item: {
                account_item_tag: null,
                account_item: { is_taggable: 0 },
                account_item_code: null,
                account_item_name: null,
                debtor_contact_id: null,
                creditor_contact_id: null,
                amount: null,
                db_amount: null,
                cr_amount: null,
                direction: null,
            },
            apply_mode_options:
            [
                {code:"INVOICE", name:"INVOICE"},
                {code:"GL", name:"GL"},
            ],
            currencies: [],
            temp_currencies:[],            
            loadCounter: 0,
            document_title: "",
            contacts: [],
            payment_modes: [
                { code: "CHEQUE", name: "CHEQUE", "requires_bankaccount": 1 },
                { code: "BANK_TRANSFER", name: "BANK_TRANSFER", "requires_bankaccount": 1 },
                { code: "CASH", name: "CASH" , "requires_bankaccount": 1},
                { code: "BULK_PAYMENT", name: "BULK_PAYMENT" , "requires_bankaccount": 1},
                { code: "DN", name: "DEBIT_NOTE", "requires_bankaccount": 0 },
                { code: "OFFSET", name: "OFFSET" , "requires_bankaccount": 0},
                { code: "REFUND", name: "REFUND" , "requires_bankaccount": 1},
                // {code:"BAD_DEBTS", name:"BAD_DEBTS"},

            ],
            is_edit: false,
            receipt: {
                tax_rate_percent:'',
                pending_offset_amount_home:0,
                apply_mode:'INVOICE',
                default_creditor_account_code: null,
                time_printed: null,
                is_void: null,
                contact: null,
                currency_code: "",
                contact_id: null,
                contact_code: '',
                contact_name: '',
                items: [],
                pitems: [],
                amount: null,
                amount_adjusted: 0,
                mode: 'CHEQUE',
                reference: '',
                remarks: "",
                currency_prefix: '',
                bankaccount_id: '',
                bankcharge_bankaccount_id: '',
                currencies:[],
                remarks:null,
            }
        }
    },
    watch: {
        // is_edit() {
        //     // this.editDocument()
        // }
    },
    async mounted() {
        await this.setDefaults()
        await this.init(this.$route.params.id)
    },

    methods:
    {
        onClickEdit()
        {
            // alert(this.is_edit)
            this.is_edit = true
            // alert(this.is_edit)
        },
        async onClickOffset()
        {
            this.receipt.mode = 'OFFSET'
            this.retrieveItems(this.receipt.contact_id)
        },        
        fxHomeAmountToCurrency(currency_code, amount)
        {
            if (currency_code == 'SGD')
                amount = amount * 1
            else
            {
                if (amount != 0 && this.receipt.currencies)
                {
                    this.receipt.currencies.forEach((o, index) => {
                        if (o.currency_code == currency_code)
                        {
                            amount = ((amount * 1) / (o.exchange_rate * 1)) * 1
                        }
                    })
                }
            }

            return amount
        },
        fxAmountToHomeCurrency(currency_code, amount)
        {
            if (currency_code == 'SGD')
                amount = amount * 1
            else
            {
                if (amount != 0 && this.receipt.currencies)
                {
                    // alert(this.receipt.currencies.length)
                    // console.log(this.receipt.currencies)

                    this.receipt.currencies.forEach((o, index) => {
                        if (o.currency_code == currency_code)
                        {
                            // if (amount == 12338.6)
                            // {
                            //     alert('here')
                            //     alert(amount * 1)
                            //     alert(o.exchange_rate)
                            //     alert(((amount * 1) * (o.exchange_rate * 1)) * 1)
                            // }
                            amount = ((amount * 1) * (o.exchange_rate * 1)) * 1
                        }
                    })
                }
            }

            return amount
        },
        printDocument()
        {
            this.loadingCounter++
            let url = 'https://reports.unityerp.com/esteam/payment-voucher/' + encodeURIComponent(localStorage.access_token)
            + '/' + encodeURIComponent(this.receipt.code)
            window.open(url , '_blank');
        
            this.loadingCounter--
        },        
        async setDefaults()
        {
            // this.default_creditor_account_code = '260100'
            // this.default_other_creditor_account_code = '260200'
            // this.default_hp_creditor_account_code = '260300'

            // this.receipt.default_creditor_account_code = this.default_creditor_account_code
        },
        async retrieveHistory(contact_id)
        {
            this.loadingCounter++

            let payload = { contact_id: contact_id}
            await axios.post(apiRoutes["PURCHASERECEIPTS_RETRIEVE_HISTORY"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.history.data = response.data.data;
                } else {
                    this.history.data = [];
                }
            })
            .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}});

            this.loadingCounter--
        },
        onFiltered(filteredItems) {
            this.history.currentPage = 1
        },
        onClickHistory()
        {
            this.retrieveHistory(this.receipt.contact_id)
            this.$bvModal.show('modal-history')
        },
        onClickAutoSum() {
            var amount = 0

            this.receipt.items.forEach((o, index) => {
                // alert(o.amount_settlement)
                amount += o.amount_settlement * 1
            })

            amount = this.fxHomeAmountToCurrency(this.receipt.currency_code, amount)
            this.receipt.amount = (amount * 1).toFixed(2)
        },
        onClickAutoApply() {
            let allocate_amount_home = parseFloat(this.receipt.amount) + parseFloat(this.receipt.amount_adjusted)
            allocate_amount_home = this.fxAmountToHomeCurrency(this.receipt.currency_code, allocate_amount_home)

            var settlement_amount = 0

            if (allocate_amount_home && allocate_amount_home <= this.total_sales_os_amount_home || 1) {
                if (this.receipt.items.length > 0) {
                    let amount_home = (allocate_amount_home * 1)
                    
                    for (let i = 0; i < this.receipt.items.length; i++) {
                        let invoice_os_amount = this.receipt.items[i].balance_exclude ? (this.receipt.items[i].balance_exclude * 1) : (this.receipt.items[i].balance * 1) * 1
                        let invoice_os_amount_home = this.fxAmountToHomeCurrency(this.receipt.items[i].currency_code, invoice_os_amount) * 1

                        this.receipt.items[i].amount = null
                        if (amount > 0) {
                            if (amount_home > invoice_os_amount_home) {
                                settlement_amount = invoice_os_amount_home * 1
                            }
                            else {
                                settlement_amount = amount_home * 1
                            }
                            this.receipt.items[i].amount_settlement = (settlement_amount * 1).toFixed(2)
                            let applied_amount = this.fxHomeAmountToCurrency(this.receipt.items[i].currency_code, settlement_amount)
                            this.receipt.items[i].amount = (applied_amount * 1).toFixed(2)
                            
                            amount = amount - settlement_amount
                        }
                        else
                        {
                            this.receipt.items[i].amount = 0
                            this.receipt.items[i].amount_settlement = 0
                        }
                    }
                }
            }
            else {
                Vue.notify({group: "notify", type: "error", text: "Invalid Payment Amount!", max: 5, duration: 5000, speed: 300,});
            }
        },        
        async onClickExchangeRates()
        {
            this.temp_currencies = this.receipt.currencies
            this.$bvModal.show('modal-currencies')
        },
        async onClickBookExchange()
        {
            this.receipt.currencies = this.temp_currencies
            this.$bvModal.hide('modal-currencies')

            this.receipt.items.forEach((o, index) => {
                o.amount_settlement = 0
                o.amount = 0
            })
        },
        performExchange(item)
        {
            if (this.is_edit)
            {
                let amount = 0
                amount = this.fxAmountToHomeCurrency(item.currency_code, item.amount)
                item.amount_settlement = (amount * 1).toFixed(2)
            }
        },
        // fxAmountToReceiptCurrency(currency_code, amount)
        // {
        //     if (amount != 0 && this.receipt.currencies)
        //     {
        //         this.receipt.currencies.forEach((o, index) => {
        //             if (o.currency_code == currency_code)
        //             {
        //                 amount = ((amount * 1) * (o.exchange_rate * 1)) * 1
        //             }
        //         })
        //     }

        //     return amount
        // },
        // fxAmountFromReceiptCurrency(currency_code, amount)
        // {
        //     if (amount != 0)
        //     {
        //         this.receipt.currencies.forEach((o, index) => {
        //             if (o.currency_code == currency_code)
        //             {
        //                 amount = ((amount * 1) / (o.exchange_rate * 1)) * 1
        //             }
        //         })
        //     }

        //     amount = (amount * 1).toFixed(2)
        //     return amount
        // },
        async init(document_id) {
            this.loadCounter++
            await this.$store.dispatch("accounts/fetchFYs", {})

            if (this.fys) {
                this.valid_fys = this.fys.filter(function (item) {
                    return (item.fy != null);
                });
                this.fy = this.valid_fys[0].fy
                this.getAllAccountsForFY()
            }

            if (document_id == '_new') {
                this.is_edit = true
                this.document_title = this.language_terms['NEW'] + " " + (this.type == 'SALES' ? this.language_terms['SALES_RECEIPT'] : this.language_terms['PURCHASE_RECEIPT'])

                if (!this.receipt.date) {
                    this.receipt.date = moment().format("YYYY-MM-DD");
                }

                if (localStorage.getItem('pv.receipt.mode'))
                    this.receipt.mode = localStorage.getItem('pv.receipt.mode')
            }
            else {
                this.is_edit = false
                await this.retrieveDocument(document_id)
                this.document_title = this.receipt.code

                await this.findEntity(this.receipt.contact_code);

                let selected_contact = {
                    id: this.receipt.contact_id,
                    code: this.receipt.contact_code,
                    name: this.receipt.contact_name,
                };

                this.receipt.contact = selected_contact;

                if (this.receipt.currency_code) {
                    await this.$store.dispatch("currencies/getPrefix", { currency_code: this.receipt.currency_code })
                    await this.$store.dispatch("bankAccounts/fetchCompanyAccounts", { currency_code: this.receipt.currency_code })
                }
                // this.receipt.currencies = []
            }
            this.loadCounter--
        },
        async findEntity(query) 
        {
            let url = this.receipt.mode == 'REFUND' ? apiRoutes["CUSTOMER_LOOKUP"] : apiRoutes["VENDOR_LOOKUP"]
            let payload = { value: query, default_creditor_account_code: this.receipt.default_creditor_account_code }
            await axios.post(url, payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.contacts = response.data.data;
                } else {
                    this.contacts = [];
                }

                this.loadingCounter--;
            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}
                });
        },
        deleteItem(index) {
            this.receipt.items.splice(index, 1);

            this.item.amount = 0
            this.receipt.amount = 0
            this.receipt.items.forEach((i, index) => {
                this.receipt.amount += (i.amount * 1)
            })
        },
        isFoundInTagList(name) {
            let is_found = 0
            for (let i = 0; i < this.contacts.length; i++) {
                if (this.contacts[i].name == name) {
                    is_found = 1
                }
            }
            return is_found;
        },
        isFoundInAccountTagList(name) {
            let is_found = 0
            for (let i = 0; i < this.item.account_item.tags; i++) {
                if (this.item.account_item.tags[i].name == name) {
                    is_found = 1
                }
            }
            return is_found;
        },
        async addTag(newTag, index) {
            if (newTag) {
                let obj = { id: null, code: null, name: newTag }
                if (this.isFoundInTagList(newTag) == 0) {
                    this.receipt.contact = obj
                    this.contacts.push(obj)
                }
                this.receipt.contact_id = null
                this.receipt.contact_code = null
                this.receipt.contact_name = newTag
            }
        },
        async addAccountItemTag(newTag, index) {
            if (newTag) {
                if (this.isFoundInTagList(newTag) == 0) {
                    this.item.account_item.tags.push(newTag)
                }
                this.item.account_item_tag = newTag
            }
        },
        async addAccountItem() {
            let amount = this.item.amount

            if (this.item.account_item == null) {
                Vue.notify({ group: 'notify', type: 'error', text: 'Account has to be selected', max: 5, duration: 5000, speed: 300 })
            }
            else if (amount == null || amount == '') {
                Vue.notify({ group: 'notify', type: 'error', text: 'Amount has to be entered', max: 5, duration: 5000, speed: 300 })
            }
            else {
                this.item.account_item_code = this.item.account_item.code
                this.item.account_item_name = this.item.account_item.name

                let item = {
                    account_item_code: this.item.account_item_code,
                    account_item_name: this.item.account_item_name,
                    debtor_contact_id: this.item.debtor_contact_id,
                    creditor_contact_id: this.item.creditor_contact_id,
                    amount: this.item.amount,
                    db_amount: this.item.db_amount,
                    cr_amount: this.item.cr_amount,
                    direction: this.item.direction,
                    remarks: this.item.remarks,
                    account_item_tag: this.item.account_item_tag,
                }

                this.receipt.items.push(item)
                this.item.amount = null

                this.item.amount = 0
                this.receipt.amount = 0
                this.receipt.items.forEach((i, index) => {
                    this.receipt.amount += (i.amount * 1)
                })
            }
        },
        async getAllAccountsForFY() {
            this.loadingCounter++
            let filter = { fy: this.fy }
            await this.$store.dispatch("accounts/getAccountForFys", filter)
            this.account_list = this.accounts_for_fy
            this.loadingCounter--
        },
        async onChangeApplyModeType() {
            this.receipt.items = []
            this.receipt.pitems = []
            this.receipt.contact = []
            await this.getCurrencies(null)
            this.receipt.currency_code = 'SGD'
            this.retrieveBankAccountsByCurrency(this.receipt.currency_code)

        },
        async getUnappliedAmount(i) {
            let amount = (this.receipt.amount * 1) + (this.receipt.amount_adjusted * 1)
            amount = this.fxAmountToHomeCurrency(this.receipt.currency_code, amount)

            let item_amount = 0
            for (let x = 0; x < this.receipt.items.length; x++) {
                if (i == x)
                    item_amount = 0
                else
                {
                    let currency_code = this.receipt.items[x].currency_code
                    let amt = this.receipt.items[x].amount * 1
                    item_amount = this.fxAmountToHomeCurrency(currency_code, amt)
                }
                    
                if (amount > item_amount)
                {
                    amount = amount - item_amount                    
                }
                else
                    amount = 0
            }

            amount = parseFloat(amount.toFixed(2))
            return amount;
        },
        async onClickApply(invoice, i) {

            if (this.is_edit && this.receipt.mode != 'CONTRA')
            {
                if (invoice.document_type == 'D')
            {
                if (invoice.amount * 1 != 0)
                {
                    invoice.amount = 0
                    invoice.amount_settlement = 0
                }
                else
                {
                    let unapplied_amount_home = 0
                    if (this.receipt.mode == 'OFFSET')
                        unapplied_amount_home = await this.getUnappliedAmount(i)
                    else
                        unapplied_amount_home  = this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance)
                        
                    let settlement_amount = 0
                    let doc_balance_receipt_currency_home = 0
                    let apply_amount = 0

                    doc_balance_receipt_currency_home = this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance)
                    if (unapplied_amount_home > doc_balance_receipt_currency_home)
                    {
                        settlement_amount = doc_balance_receipt_currency_home
                    }
                    else
                    {
                        settlement_amount = unapplied_amount_home
                    }
                    apply_amount = this.fxHomeAmountToCurrency(this.receipt.items[i].currency_code, settlement_amount)
                    
                    invoice.amount = (apply_amount * 1).toFixed(2)
                    invoice.amount_settlement = (settlement_amount * 1).toFixed(2)
                }
            }
            else if (invoice.document_type == 'R')
            {
                let settlement_amount = 0
                let doc_balance_receipt_currency = 0
                let apply_amount = 0
                let allow = 1
                let doc_balance_receipt_currency_home = 0

                allow = 1

                if (allow)
                {
                    if (invoice.amount * 1 != 0)
                        doc_balance_receipt_currency_home = 0
                    else
                    {
                        // alert(invoice.currency_code)
                        // alert(invoice.balance)
                        doc_balance_receipt_currency_home = this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance) * -1
                        // alert(doc_balance_receipt_currency_home)

                    }
                    settlement_amount = doc_balance_receipt_currency_home
                    apply_amount = this.fxHomeAmountToCurrency(this.receipt.items[i].currency_code, settlement_amount)
                    
                    invoice.amount = (apply_amount * 1).toFixed(2)
                    invoice.amount_settlement = (settlement_amount * 1).toFixed(2)            
                }
            }

            this.$set(this.receipt.items, i, invoice)

            if (this.receipt.mode == 'REFUND')
                this.onClickAutoSum()
            }
        },
        async saveDocument()
        {
            let proceed = 1

            if (this.receipt.pending_offset_amount_home != 0)
            {
                proceed = 0
                let response = await this.$confirm('Proceed', 'O/S Offset Amount', {
                        cancelButtonText: this.language_terms['CANCEL'],
                        confirmButtonText: this.language_terms['CONFIRM'],
                        type: 'warning'
                        }).catch(() => 
                        {
                            // this.$message.info(this.language_terms['ACTION_CANCEL'])
                            proceed = 0
                        })

                if (response === 'confirm') 
                {
                    proceed = 1
                }
            }

            if (this.$route.params.id == '_new') {
                if (proceed == 1)
                    this.create()
            }
            else {
                this.update()
            }
        },
        async voidDocument() {
            await this.$store.dispatch("receipts/void", { "id": this.receipt.id })

            if (this.receipt_is_voided) {
                await this.searchReceipts()
                await this.routeToMaster();
            }
        },
        async editDocument() {
            window.location.href = '/finance/purchase-receipt/_new';
        },
        async retrieveDocument(code) {
            await this.$store.dispatch("receipts/fetch", { code: code, type: this.type });
            this.receipt = this.receipt_data;
        },
        async searchReceipts() {
            this.loadCounter++
            let filter = {
                keyword: "",
                date_from: null,
                date_to: null,
            }
            if (this.receipt_filter) {
                filter = this.receipt_filter
            }
            await this.$store.dispatch('receipts/quickSearch', filter)

            this.loadCounter--
        },        
        async update() {
            let url = apiRoutes['UPDATE_PURCHASE_RECEIPT']
            let msg = ''
            let payload = this.receipt
            await axios.post(url, payload, authHeader()).then((res) => {
                let response = res.data
                if (response.code == 1) 
                {
                    let receipt_code = response.data.code
                    Vue.notify({ text: 'Receipt (' + receipt_code + ')' + " has been updated!", type: 'success', group: 'notify', max: 5, duration: 5000, speed: 300 })
                    window.location.href = '/finance/purchase-receipt/' + receipt_code;
                } else 
                {
                    if (Array.isArray(response.data.errors)) 
                    {
                        msg = response.data.errors.join("\n")
                    }
                    else
                    {
                        msg = response.msg
                    }
                    Vue.notify({ text: msg, type: 'error', group: 'notify', max: 5, duration: 5000, speed: 300 })
                }
            })
            .catch((error) => {
            if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
           }});

            // this.receipt.type = this.type

            // await this.$store.dispatch("receipts/update", this.receipt)

            // if (this.is_receipt_updated) {
            //     await this.searchReceipts()
            //     await this.routeToMaster();
            // }

        },
        async create() {
            localStorage.setItem('pv.receipt.mode', this.receipt.mode)

            let url = apiRoutes['CREATE_PURCHASE_RECEIPT']
            let msg = ''
            let payload = this.receipt
            await axios.post(url, payload, authHeader()).then((res) => {
                let response = res.data
                if (response.code == 1) 
                {
                    let receipt_code = response.data.code
                    Vue.notify({ text: 'Receipt (' + receipt_code + ')' + " has been created!", type: 'success', group: 'notify', max: 5, duration: 5000, speed: 300 })
                    window.location.href = '/finance/purchase-receipt/' + encodeURIComponent(receipt_code);
                } else 
                {
                    if (Array.isArray(response.data.errors)) 
                    {
                        msg = response.data.errors.join("\n")
                    }
                    else
                    {
                        msg = response.msg
                    }
                    Vue.notify({ text: msg, type: 'error', group: 'notify', max: 5, duration: 5000, speed: 300 })
                }
            })
            .catch((error) => {
            if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
           }});
        },
        async routeToMaster() {
            if (this.type == "PURCHASE") {
                this.$router.push("/finance/purchase-receipts");
            }

        },
        onClickClose() {
            this.$router.push("/finance/purchase-receipts")
        },
        moment: function () {
            return moment();
        },
        async retrieveItems(contact_id) {
            this.loadCounter++

            this.receipt.pending_offset_amount_home = 0
            this.receipt.items = []
            this.receipt.pitems = []
            
            if (this.receipt.mode == 'REFUND')
            {
                this.receipt.apply_mode = 'INVOICE'
            }

            if (contact_id != null && contact_id != '') {
                await this.retrieveBankAccountsByCurrency(this.receipt.currency_code)
                if (this.receipt.mode != 'REFUND')
                {
                    let include_receipts = 0

                    if (this.receipt.mode == 'OFFSET')
                        include_receipts = 1

                    let payload = {contact_id: contact_id, include_receipts:include_receipts, currency_code: this.receipt.currency_code}
                    await axios.post(apiRoutes["PURCHASE_RETRIEVE_OS_INVOICES"], payload, authHeader()).then((response) => {
                        if (response.data.code == 1) {
                            this.receipt.pending_offset_amount_home = response.data.data.pending_offset_amount_home                    
                            this.receipt.items = response.data.data.items
                            this.receipt.currencies = response.data.data.currencies
                            // alert(response.data.data.currencies.length)
                        } else {
                            this.receipt.items = [];
                        }
                    }).catch((error) => {if (error.response) {Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });}});
                }
                else
                {
                    let payload = {contact_id: contact_id, currency_code: this.receipt.currency_code}
                    await axios.post(apiRoutes["SALESRECEIPTS_RETRIEVE_EXCESS"], payload, authHeader()).then((response) => {
                        if (response.data.code == 1) {
                            this.receipt.items = response.data.data.items
                            this.receipt.currencies = response.data.data.currencies
                        } else {
                            this.receipt_items = [];
                        }
                    })
                    .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}});
                }
                await this.getCurrencies(contact_id)

                this.receipt.amount = 0
                this.receipt.amount_adjusted = 0
                this.receipt.reference = null
            }
            this.loadCounter--                
        },
        async retrieveBankAccountsByCurrency(currency_code) {
            await this.$store.dispatch("bankAccounts/fetchCompanyAccounts", { currency_code: currency_code })

            if (this.company_bankaccounts.length > 0) {
                this.receipt.bankaccount_id = this.company_bankaccounts[0].id
                this.receipt.bankcharge_bankaccount_id = this.company_bankaccounts[0].id
            }

            this.receipt.currency_prefix = this.currency_prefix

        },
        async onSelectEntity(selectedOption) {
            if (selectedOption) {
                this.receipt.currency_code = selectedOption.currency_code

                if (this.$route.params.id == '_new' && this.receipt.apply_mode == 'INVOICE') {
                    await this.retrieveItems(selectedOption.id)
                }

                if (selectedOption.currency_code) {
                    await this.getCurrencies(selectedOption.id)
                    await this.$store.dispatch("currencies/getPrefix", { currency_code: selectedOption.currency_code })
                    await this.retrieveBankAccountsByCurrency(selectedOption.currency_code)
                }

                if (this.receipt.apply_mode == 'GL')
            {
                this.receipt.items = []
                this.receipt.pitems = []
            }                
                this.receipt.contact_id = selectedOption.id
            }
        },
        limitText(count) {
            return `and ${count} other contacts`;
        },
        async getCurrencies(contact_id) {
            this.loadCounter++
            let pv = {};
            await axios.post(apiRoutes["CURRENCIES_LIST"], pv, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.currencies = response.data.data;
                } else {
                    this.currencies = [];
                }
            })
            .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}});
            this.loadCounter--
        },
    }
}
</script>
